import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ActionCardConfig {
  title?: string;
  iconSrc?: string;
  primaryButtonText: string;
  primaryButtonIconSrc?: string;
  primaryButtonDisabled?: boolean;
  secondaryButtonText?: string;
  secondaryButtonIconSrc?: string;
  descriptionText?: string;
}

@Component({
  selector: 'app-action-card',
  templateUrl: './action-card.component.html',
  styleUrls: ['./action-card.component.scss']
})
export class ActionCardComponent {
  @Input() config!: ActionCardConfig;
  @Output() primaryButtonClicked = new EventEmitter<void>();
  @Output() secondaryButtonClicked = new EventEmitter<void>();
}
